/* eslint-disable max-len */
import React from 'react'
import { ShimmerBadge,
    ShimmerButton,
    ShimmerTitle,ShimmerThumbnail,ShimmerSectionHeader, ShimmerCircularImage, ShimmerText } from 'react-shimmer-effects'
function OffersProductsSkeleton() {
    return (
        <>{[...Array(5)].map((item)=>(
            <div className="rounded-lg bg-[#FFFFFF] shadow-s7 px-4 pb-1.5 mt-2 relative" key={item}>
                <div className="flex flex-wrap">
                    <div className="xl:w-[75%] w-full pt-2">
                        <div className="flex">
                            <div className="w-1/4">
                                <ShimmerThumbnail height={80} className="cursor-pointer w-3.5 h-3.5" />
                            </div>
                            <div className="pl-2.5">
                                <div className="flex sm:items-center items-start sm:flex-row flex-col">
                                    <p className="sm:text-xl text-base font-bold text-[#090406]">
                                        <ShimmerTitle line={1} gap={10} variant="primary" /></p>
                                    <ShimmerBadge width={250}/>
                                </div>
                                <p className="sm:text-xs6 text-xs2 font-normal text-[#808285] mt-1"><ShimmerBadge width={450}/></p>
                                <div className="mt-2 flex sm:items-center items-baseline sm:flex-row flex-col">
                                    <div className="flex sm:border-r sm:border-[#707070] sm:pr-[6px] w-fit items-center">
                                        <ShimmerBadge width={500}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="lg:w-[80%] w-full lg:px-4 pt-2.5 pb-3.5">
                        <div className="flex sm:flex-row flex-col">
                            <div className="flex items-center sm:w-[50%] w-full">
                                <div className="w-[50%]">
                                    <p className="text-xs font-semibold text-[#808285]"><ShimmerBadge width={100}/></p>
                                    <p className="text-xs6 font-semibold text-[#555259]"><ShimmerBadge width={40}/></p>
                                </div>
                                <div className="w-1/2">
                                    <p className="text-xs font-semibold text-[#808285]"><ShimmerBadge width={90}/></p>
                                    <p className="text-xs6 font-semibold text-[#555259]"><ShimmerBadge width={50}/></p>
                                </div>
                            </div>
                            <div className="flex items-center sm:w-[50%] w-full sm:mt-0 mt-3">
                                <div className="w-1/2">
                                    <p className="text-xs font-semibold text-[#808285]"><ShimmerBadge width={110}/></p>
                                    <p className="text-xs6 font-semibold text-[#555259]"><ShimmerBadge width={50}/></p>
                                </div>
                                <div className="w-1/2">
                                    <p className="text-xs font-semibold text-[#808285]"><ShimmerBadge width={50}/></p>
                                    <p className="text-xs6 font-semibold text-[#555259]"><ShimmerBadge width={70}/></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="pt-2 border-t border-[#CBCBCB] w-full flex items-center xl:flex-row flex-col lg:px-4 px-0">
                        <div className="flex items-center xl:justify-start xl:w-[37%] w-full justify-between">
                            <div className="xl:w-[65%] w-full">
                                <p className="text-xs3 font-semibold text-[#808285]"><ShimmerText line={1} gap={10} variant="primary" /></p>
                                <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#15090E]"><ShimmerBadge width={50}/></p>
                            </div>
                            <div className="sm:ml-[30px] ml-4">
                                <p className="text-xs3 font-semibold text-[#808285] text-center mr-[17px] "><ShimmerText line={1} gap={10} variant="primary" /></p>
                                <div className="flex justify-center pt-2">
                                    <ShimmerButton size="sm"/>
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center justify-between xl:w-[73%] w-full xl:mt-0 mt-4">
                            <div className="xl:ml-10">
                                <p className="text-xs3 font-semibold text-[#808285]"><ShimmerText line={1} gap={10} variant="primary" /></p>
                                <ShimmerBadge width={50}/>
                            </div>
                            <div className="md:min-w-[284px] w-[150px] bg-[#f0f0f0] rounded-lg text-center py-1.5">
                                <p className="text-xs2 font-semibold text-[#808285]"><ShimmerText line={1} gap={10} variant="primary" /></p>
                                <p className="md:text-xs4 text-base font-semibold text-[#15090E] sm:pt-0.5"><ShimmerBadge width={50}/></p>
                            </div>
                        </div>
                    </div>
                    <p className="lg:px-4 mt-2 text-xs3 font-normal text-[#808285] flex items-center">
                        <ShimmerText line={1} gap={10} variant="primary" />                                    </p>
                    <button type="button" data-bs-toggle="modal" data-bs-target="#exampleModalCenter2">
                        <ShimmerCircularImage size={20} className="absolute sm:top-6 top-[17px] sm:right-[60px] right-[50px] cursor-pointer"/>
                    </button>
                    <button type="button" data-bs-toggle="modal" data-bs-target="#removefromWishes">
                        <ShimmerCircularImage size={20} className="absolute sm:top-6 top-[17px] right-[22px] cursor-pointer"/>
                    </button>
                </div>
            </div>
        ))}</>
    )
}

export default OffersProductsSkeleton